var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_149",
    "data-name": "\\uADF8\\uB8F9 149",
    transform: "translate(-1028 -335)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_86",
    "data-name": "\\uC0AC\\uAC01\\uD615 86",
    width: 32,
    height: 32,
    transform: "translate(1028 335)",
    fill: "#ff2727",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-circle",
    "data-name": "Icon awesome-user-circle",
    d: "M12,.563a12,12,0,1,0,12,12A12,12,0,0,0,12,.563Zm0,4.645A4.258,4.258,0,1,1,7.742,9.466,4.258,4.258,0,0,1,12,5.208Zm0,16.645a9.272,9.272,0,0,1-7.089-3.3,5.4,5.4,0,0,1,4.766-2.894,1.184,1.184,0,0,1,.344.053A6.407,6.407,0,0,0,12,16.046a6.382,6.382,0,0,0,1.979-.334,1.184,1.184,0,0,1,.344-.053,5.4,5.4,0,0,1,4.766,2.894A9.272,9.272,0,0,1,12,21.853Z",
    transform: "translate(1032 338.438)",
    fill: "#ccdfff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInfo);
export default __webpack_public_path__ + "static/media/user_info.017979aa7b591b891f44438ee4e9f6cf.svg";
export { ForwardRef as ReactComponent };